import frequencyList from "./decision-type/frequencyList";

export default [...frequencyList];